import React from 'react';
import { ArcStack } from '@src/core/ui';
import { useParams } from 'react-router-dom';
import { ArcSocketContext, ChannelRequestEnum } from '@src/core/socket';
import FlightData from '@src/features/drone/components/flight-data';
import {
  EnRouteDroneInfo,
  EnRouteEmergencyButtons,
  EnRouteFlightMode,
  EnRouteIndicator,
  EnRouteManualControl,
  EnRouteStatusMessage,
  EnRouteTopDronesCarousel,
} from './components';
import { EnRouteSidebarProps } from './types';

const SidebarEnRoute: React.FC<EnRouteSidebarProps> = (props) => {
  const { data, viewer } = props;

  const { missionId } = useParams();
  const { arcSocket, readyState } = React.useContext(ArcSocketContext);

  React.useEffect(() => {
    const socket = arcSocket();
    if (socket === null || socket.readyState !== WebSocket.OPEN) return;
    
    const payload = { type: ChannelRequestEnum.GET_FLIGHT_DATA, data: { missionId  } };
    socket.send(JSON.stringify(payload));
        
    return () => {
      const payload = { type: ChannelRequestEnum.STOP_FLIGHT_DATA };
      socket.send(JSON.stringify(payload));
    };
  }, [readyState]);

  
  return (
    <ArcStack spacing={2}>
      <EnRouteTopDronesCarousel missionDrone={data?.drone} viewer={viewer} />
      <EnRouteDroneInfo drone={data?.drone} />
      {viewer ? null : <EnRouteEmergencyButtons drone={data?.drone} />}
      <ArcStack spacing={1} direction='row' justifyItems={'center'} alignItems={'center'}>
        <FlightData droneSerial={data?.drone?.serialNumber} />
        <EnRouteIndicator />
      </ArcStack>
      <EnRouteStatusMessage  missionId={missionId} />
      <EnRouteFlightMode missionId={missionId} />
      {viewer ? null : <EnRouteManualControl drone={data?.drone} />}
    </ArcStack>

  );
};

export default SidebarEnRoute;